"use strict";

var PaperProduct = require('../interfaces/PaperProduct');

module.exports = function (product) {
  var otherProductTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var constants = arguments.length > 2 ? arguments[2] : undefined;

  if (!Object.prototype.isPrototypeOf.call(PaperProduct.prototype, product)) {
    return false;
  }

  var packages_requiring_odd_postage = [constants.FLORAL_WEDDING_INVITATIONS, constants.FLORAL_WEDDING_INVITATION_REPRINTS, constants.RIBBON_WEDDING_INVITATIONS, constants.RIBBON_WEDDING_INVITATION_REPRINTS, constants.WAX_SEALS, constants.SILK_RIBBON];

  if (product.waxSeals && product.waxSeals.quantity) {
    return true;
  }

  if (otherProductTypes.includes(constants.WAX_SEALS) || otherProductTypes.includes(constants.SILK_RIBBON)) {
    return true;
  }

  if (product.components.some(function (_ref) {
    var acc_ribbon = _ref.acc_ribbon;
    return acc_ribbon && !acc_ribbon.match(/none/i);
  })) {
    return true;
  }

  if (packages_requiring_odd_postage.includes(product.product_type)) {
    return true;
  }

  if (product.paper_type.match(/double thick/i)) {
    return true;
  }

  return false;
};